import { useMapState } from "contexts/MapStateContext";
import { BASEMAP_LAYERS } from "components/mapSetup";
import { Select, MenuItem } from "@mui/material";

export default function BaseLayer() {
  const { basemap, setBasemap } = useMapState();

  return (
    <Select
      sx={{ width: "100%" }}
      variant="standard"
      value={basemap}
      onChange={(event) => setBasemap(event.target.value)}
    >
      <MenuItem value="default">Satellite</MenuItem>
      {Object.entries(BASEMAP_LAYERS).map(([key, config]) => (
        <MenuItem key={key} value={key}>
          {config.name}
        </MenuItem>
      ))}
    </Select>
  );
}
